import React from 'react';
import classnames from 'classnames';

import styles from './TextStylesUsage.css';

const TextStylesUsage = () => (
  <section>
    <article className="flex-row last flex-justify-end'">
      <div className="left">
        <h1 className="h1 page-title">
          Typography communicates hierarchy, value, character, and identity for each page.
        </h1>
      </div>
      <div className="right copy-content">
        <p>It has an impact on the way a website is perceived as it affects aspects of readibility, mood, user experience, and even an article’s length.</p>
        <p>Its size is particularly crucial in ranking and highlighting different content in a page. When applying larger sizes for the text, it seemed natural to only use Tondo Light because its characters are lighter, making the composition and visual balance of the page greater. It also renders better in small sizes, making reading more comfortable.</p>
        <p>Airtel’s brand typeface, Tondo, with all its glyphs sums a total of +/− 1MB. Because of its size, the brand’s website was being designed with Arial — a system alternative that has little impact on performance.</p>
        <p>In order to maintain the brand’s identity and not impact performance goals, font size had to be reduced. It was achieved by reducing the amount of glyphs in the webfont.</p>

        <table className={styles.totalsTable}>
          <tbody>
            <tr>
              <td>Total glyphs in font:</td>
              <td><b>480</b>, which represents about 1MB</td>
            </tr>
            <tr>
              <td>Characters to remove:</td>
              <td><b>342</b></td>
            </tr>
            <tr>
              <td>Glyphs to add:</td>
              <td><b>1</b></td>
            </tr>
            <tr>
              <td>New font total glyphs:</td>
              <td><b>144</b>, which represents about 55KB</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.textBlock}>
          <h2 className="h2 page-subtitle">Uppercase</h2>
          <p className={classnames('section-title', styles.textSamples)}>
            A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
          </p>
        </div>

        <div className={styles.textBlock}>
          <h2 className="h2 page-subtitle">Lowercase</h2>
          <p className={classnames('section-title', styles.textSamples)}>
            a b c d e f g h i j k l m n o p q r s t u v w x y z
          </p>
        </div>

        <div className={styles.textBlock}>
          <h2 className="h2 page-subtitle">Numbers</h2>
          <p className={classnames('section-title', styles.textSamples)}>
            0 1 2 3 4 5 6 7 8 9
          </p>
        </div>

        <div className={styles.textBlock}>
          <h2 className="h2 page-subtitle">Ponctuation & Special Characters</h2>
          <p className={classnames('section-title', styles.textSamples)}>
            {
              // eslint-disable-next-line no-useless-escape
              '! ” # ’ ( ) * , - . / : ; ? [ \ ] _ { } « · » – — ’ “ ” „ • …% & + < = > @ ^ | ~ © ® ° ± × ÷ ™ ∞ ≈ ≠ ≤ ≥'
            }
          </p>
        </div>
      </div>
    </article>
  </section>
);

export default TextStylesUsage;



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/TextStylesUsage/TextStylesUsage.js